export class DomainError extends Error {
  readonly code: string;
  readonly httpStatus: number;
  readonly details?: Record<string, unknown>;
  constructor(code: string, message: string, httpStatus = 400, details?: Record<string, unknown>) {
    super(message);
    this.name = 'DomainError';
    this.code = code;
    this.httpStatus = httpStatus;
    this.details = details;
  }
}

export class NotFoundError extends DomainError {
  constructor(entity: string, id: string) {
    super('not_found', `${entity} not found: ${id}`, 404, { entity, id });
  }
}

export class InvalidTransitionError extends DomainError {
  constructor(entity: string, from: string, to: string) {
    super('invalid_transition', `${entity} cannot transition ${from} → ${to}`, 409, { entity, from, to });
  }
}

export class PeriodLockedError extends DomainError {
  constructor(month: string) {
    super('period_locked', `Period ${month} is closed; corrections must post to the current month.`, 409, { month });
  }
}

export class RuleViolationError extends DomainError {
  constructor(rule: string, message: string, details?: Record<string, unknown>) {
    super('rule_violation', message, 422, { rule, ...details });
  }
}
